// extracted by css-extract-rspack-plugin
export default {"root":"root-w98rJD text-sm-medium","postingCount":"postingCount-JE4Edo"};